import React from 'react';
import { Navigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { getUserInfo } from '../../utils/auth';
import { UserRole } from '../../constants/user';

interface RoleRouteProps {
  children: React.ReactElement;
  allowedRoles: UserRole[];
  redirectTo?: string;
}

/**
 * 基于角色的路由保护组件
 * 只有指定角色的用户才能访问，否则显示无权限页面或重定向
 */
const RoleRoute: React.FC<RoleRouteProps> = ({ 
  children, 
  allowedRoles,
  redirectTo 
}) => {
  const userInfo = getUserInfo();
  
  // 检查用户角色是否在允许的角色列表中
  const hasPermission = userInfo && allowedRoles.includes(userInfo.role as UserRole);

  if (!hasPermission) {
    // 如果指定了重定向路径，则重定向
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }

    // 否则显示无权限页面
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '60vh' 
      }}>
        <Result
          status="403"
          title="403"
          subTitle="抱歉，您没有权限访问此页面。"
          extra={
            <Button type="primary" onClick={() => window.history.back()}>
              返回上一页
            </Button>
          }
        />
      </div>
    );
  }

  return children;
};

export default RoleRoute;
